export enum ItemType {
    Record, Model
}
